/**
 * Semantic design tokens — single source of truth for the YuMuuv palette.
 *
 * IMPORTANT: keep the hex values in `src/styles/_variables.scss` (:export block
 * and declared variables) in sync with this file. A Jest test enforces parity.
 *
 * Contrast verification lives in `scripts/verify-contrast.js` and runs on CI.
 *
 * Usage rules enforced by convention (and documented below):
 * - `brand.blue` is used for text only on white / tinted backgrounds. On
 *   `surface.muted` (#F5F5F9), use `brand.blueHover` for text (passes 4.5:1).
 * - `border.default` is used on white / tinted surfaces. On `surface.muted`,
 *   use `brand.blueHover` or `brand.bluePressed` for UI-boundary contrast.
 * - Focus rings use `outline-offset >= 2px` so the ring always sits on the
 *   surrounding surface, not on the filled button itself.
 */

export const tokens = {
  brand: {
    blue: '#006CFA',
    blueHover: '#0061DE',
    bluePressed: '#004DB0',
    blueTint: 'rgba(0, 108, 250, 0.10)',
  },
  text: {
    primary: '#0D1F50',
    secondary: '#495881',
    onBrand: '#FFFFFF',
    disabled: '#8A8EA5',
  },
  border: {
    default: '#8A8EA5',
    subtle: '#EDEFF6',
    focus: '#004DB0',
  },
  surface: {
    background: '#FFFFFF',
    muted: '#F5F5F9',
    tint: '#F2F8FF',
    appBackground: '#F2F2F6',
  },
  status: {
    error: '#D7263D',
    success: '#318713',
    successDark: '#067C00',
  },
} as const

export type Tokens = typeof tokens
